import { CSSProperties } from 'react';
import { TableCellType } from 'entities/Files/types';
import { ColorPalette } from 'shared/consts/colorPalette';

export const cellStyle: CSSProperties = {
	minWidth: '80px',
	padding: '5px',
	border: '1.5px solid',
	borderColor: ColorPalette.zircon,
	lineHeight: '0px',
};

export const MAX_TABLE_HEIGHT = 700;
export const ESTIMATED_ROW_HEIGHT = 32;

export const resolveTableCellValue = (cell: TableCellType | undefined) => {
	const resolvedValue = cell?.assertionsData?.replaceVal || cell?.content || '';
	const isUnresolvedMulti = cell?.status === 'MULTI' && !cell?.manualOverride;
	return {
		resolvedValue,
		displayValue: isUnresolvedMulti ? 'Multi' : resolvedValue,
		isUnresolvedMulti,
	};
};

export const getRowIndexes = (cells: TableCellType[]) =>
	Array.from(new Set(cells.map((cell) => cell.rowIndex))).sort((a, b) => a - b);

export const getCellMap = (cells: TableCellType[]) => {
	const map = new Map<string, TableCellType>();
	cells.forEach((cell) => map.set(`${cell.rowIndex}:${cell.columnIndex}`, cell));
	return map;
};
